export default __webpack_public_path__ + "static/media/img-1.98c8d257.png";